import { render, staticRenderFns } from "./animals.vue?vue&type=template&id=1137ac9f"
import script from "./animals.vue?vue&type=script&lang=js"
export * from "./animals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports